import { useQuery } from '@tanstack/react-query';

import { useCurrentOrgId } from '@/features/org/hooks/use-current-org-id';
import { checkOrgSubscription } from '@/features/subscriptions/api/check-subscription';

export const ORG_SUBSCRIPTION_QUERY_KEY = 'org-subscription';

export function useOrgSubscription() {
  const currentOrgId = useCurrentOrgId();

  return useQuery({
    queryKey: [ORG_SUBSCRIPTION_QUERY_KEY, currentOrgId],
    queryFn: () => checkOrgSubscription(currentOrgId ?? 0),
    enabled: !!currentOrgId,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
}
